module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_shimbishika-5e208d2fbd6488825950944e929a1011.png";